
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { DialogFooter } from '@/components/ui/dialog';
import { Division } from '@/types/division';

interface DivisionFormProps {
  editingDivision: Division | null;
  divisionName: string;
  setDivisionName: (name: string) => void;
  travelLevel: string;
  setTravelLevel: (level: string) => void;
  birthDateCutoff: string;
  setBirthDateCutoff: (date: string) => void;
  isSubmitting: boolean;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}

export const DivisionForm: React.FC<DivisionFormProps> = ({
  editingDivision,
  divisionName,
  setDivisionName,
  travelLevel,
  setTravelLevel,
  isSubmitting,
  onSubmit,
  onCancel,
}) => {
  return (
    <form onSubmit={onSubmit}>
      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Label htmlFor="division-name">Division Name</Label>
          <Input
            id="division-name"
            value={divisionName}
            onChange={(e) => setDivisionName(e.target.value)}
            placeholder="e.g., Premier Division, Division A, etc."
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="travel-level">Travel Level</Label>
          <Select value={travelLevel} onValueChange={setTravelLevel}>
            <SelectTrigger>
              <SelectValue placeholder="Select travel level" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="none">No travel level</SelectItem>
              <SelectItem value="local">Local</SelectItem>
              <SelectItem value="in_state">In-State</SelectItem>
              <SelectItem value="out_of_state">Out-of-State</SelectItem>
              <SelectItem value="international">International</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Saving...' : editingDivision ? 'Update' : 'Create'}
        </Button>
      </DialogFooter>
    </form>
  );
};
